import _ from 'lodash';
import { loadable } from '../../../common/utils/lazyLoading';
import useT from '../../../common/components/utils/Translations/useT';
const MyDrive = loadable(() => import('../MyDrive'));
const PublicDrive = loadable(() => import('../MyDrive/PublicDrive'));
export default ({ accessList, edDriveAccessList, entityLocations }) => {
    const t = useT();
    const pages = [];
    const currentPetIds = _.uniq(_.map(_.filter(entityLocations, { status: 'ACTIVE' }), 'personEntityTypeId'));
    const hasPublicDrivePermission = id => {
        var _a;
        return ((_a = _.find(edDriveAccessList, x => x.personEntityTypeId === id)) === null || _a === void 0 ? void 0 : _a.permissions.includes('administration.ed_drive.public_drive')) || false;
    };
    const getPetName = id => _.find(_.filter(entityLocations, { status: 'ACTIVE' }), x => x.personEntityTypeId === id).personEntityType.name;
    if (accessList === null || accessList === void 0 ? void 0 : accessList.includes('administration.ed_drive.my_drive')) {
        pages.push({
            id: 'my_drive',
            title: 'My Drive',
            route: 'my-drive',
            component: MyDrive,
            icon: 'server',
            permission: 'administration.ed_drive.my_drive',
        });
    }
    for (const petId of currentPetIds) {
        if (hasPublicDrivePermission(petId)) {
            pages.push({
                id: `public_drive_${petId}`,
                title: t(`Public Drive - #{petName}`, {
                    petName: t(getPetName(petId)),
                }),
                translated: true,
                route: `public-drive/${petId}`,
                component: PublicDrive,
                icon: 'folder-open',
                permission: 'administration.ed_drive.public_drive',
            });
        }
    }
    return pages;
};
